import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { AppStore } from "../../stores/AppStore";
import { Alert, Alignment, Button, Classes, Dialog, FormGroup, H5, Icon, InputGroup, Intent, Menu, MenuItem, NonIdealState, NumericInput, Popover, Position } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBDropdown, MDBDropdownItem, MDBDropdownMenu, MDBDropdownToggle, MDBRow } from "mdbreact";
import { toast } from "react-toastify";
import { BootstrapTable, SearchField, TableHeaderColumn, } from "react-bootstrap-table";
import { Pager } from "../utils/Pager";
import { debounce } from "underscore";
import moment from "moment";
import { AcumuladoresStore } from "../../stores/acumuladores/AcumuladoresStore";
import { formatCnpj } from "../../utils";
import { ICalc, IEmpresa, newEmpresa } from "../../model";
import { EmpresaSelect, filterEmpresa, renderEmpresa } from "../empresa/EmpresaSelect";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { CalcSelect } from "../calculos/CalcSelect";
import { filterCalcs, renderCalcs } from "../utils/CalcSelect";
import LoadingModal from "../loading/LoadingModal";
import ReactJson from "react-json-view";
import Dropzone from "react-dropzone";
import { AppIcon } from "../utils/AppIcon";

@observer
export class AcumuladoresPage extends React.Component<{}, {}> {

  obs = observable({
    open_create: false as boolean,
    open_edit: false as boolean,
    open_erros: false as boolean,
    open_importar_acumuladores: false as boolean,
    open_copiar_acumuladores: false as boolean,
    open_delete_all: false as boolean,
    open_detalhes_import: false as boolean,
    open_select_empresa: false as boolean,

    isEmpresa: false as boolean,

    loading_save: false as boolean,
    loading_import: false as boolean,
    loading_copiar: false as boolean,
    loading_delete_all: false as boolean,
    loading_exportar: false as boolean,
    loading_exportar_modelo: false as boolean,
    id: null as string,
    n_acumulador: "" as string,
    listCalcs: [] as any,
    erros: [] as any,
    resp_data: [] as any,
    fetchOptions: {} as any,
    calc_selecionado: null,
    tempSelectEmpresa: newEmpresa() as IEmpresa,
    selectEmpresa: newEmpresa() as IEmpresa,
    selectEmpresaDuplicar: newEmpresa() as IEmpresa,
  })

  constructor(props) {
    super(props);

    this.obs.fetchOptions = debounce(this.handleBuscaAcumuladores.bind(this), 800);

  }

  async componentDidMount() {

    AcumuladoresStore.obs.acumuladores = []
    AcumuladoresStore.obs.acumuladores_length = 0
    AcumuladoresStore.obs.acumuladores_current = 1
    AcumuladoresStore.obs.filter_calculo = ""
    AcumuladoresStore.obs.filter_acumulador = ""

    this.obs.selectEmpresa = newEmpresa()
    this.obs.tempSelectEmpresa = newEmpresa()
    this.obs.selectEmpresaDuplicar = newEmpresa()

    this.obs.open_select_empresa = true

  }

  handleOpenCreate() {

    this.obs.id = ""
    this.obs.n_acumulador = ""
    this.obs.listCalcs = []

    this.obs.open_create = true

  }

  async handleSaveCreate() {

    if (!this.obs.n_acumulador) {
      toast.warn("Favor preencha o campo Acumulador!", {})
      return
    }

    if (!this.obs.listCalcs.length) {
      toast.warn("Favor selecione pelo menos um Cálculo!", {})
      return
    }

    if (!this.obs.selectEmpresa.cnpj) {
      toast.warn("Favor selecione uma Empresa!", {})
      return
    }

    this.obs.loading_save = true
    this.obs.open_create = false

    let data = {
      cnpj: this.obs.selectEmpresa.cnpj,
      n_acumulador: parseInt(this.obs.n_acumulador),
      calcs: this.obs.listCalcs,
      tipo: "sped"
    }

    let resp = await AcumuladoresStore.handleCreateAcumulador(data)

    await this.handleBuscaAcumuladores()

    this.obs.loading_save = false

    if (!resp) {

      toast.error('Erro ao cadastrar acumulador, tente novamente mais tarde.', {});

    } else if (!resp.length) {

      toast.success('Acumuladores cadastrados com sucesso.', {});

    } else {

      this.obs.open_erros = true
      this.obs.erros = resp

    }

  }

  async handleSaveEdit() {

    if (!this.obs.n_acumulador) {
      toast.warn("Favor preencha o campo Acumulador!", {})
      return
    }

    if (!this.obs.calc_selecionado._id) {
      toast.warn("Favor selecione um Cálculo!", {})
      return
    }

    if (!this.obs.selectEmpresa.cnpj) {
      toast.warn("Favor selecione uma Empresa!", {})
      return
    }

    this.obs.loading_save = true
    this.obs.open_edit = false

    let data = {
      id: this.obs.id,
      n_acumulador: parseInt(this.obs.n_acumulador),
      calc_id: this.obs.calc_selecionado._id,
      calc_nome: this.obs.calc_selecionado.nome,
    }

    let resp = await AcumuladoresStore.handleUpdateAcumulador(data)

    if (resp) await this.handleBuscaAcumuladores()

    this.obs.loading_save = false

  }

  createCustomSearchFieldSol = (props) => {
    return (
      <SearchField
        className="input-filter input-filter-ajuste"
        defaultValue={props.defaultSearch}
        placeholder="Filtrar (Código, Descrição)"
      />
    );
  };

  async handleChangePage(page: number) {

    AcumuladoresStore.obs.acumuladores_current = page

    await AcumuladoresStore.handleBuscaAcumuladores(
      page,
      this.obs.selectEmpresa.cnpj,
      this.obs.selectEmpresa.uf,
      AcumuladoresStore.obs.filter_calculo,
      AcumuladoresStore.obs.filter_acumulador
    )

  }

  async handleEditAjuste(row) {

    this.obs.id = row.id
    this.obs.n_acumulador = row.n_acumulador

    this.obs.calc_selecionado = AcumuladoresStore.obs.calcs.find(x => x._id == row.calc_id)

    this.obs.open_edit = true

  }

  async handleDeleteAcumulador(id) {

    let resp = await AcumuladoresStore.handleDeleteAcumulador(id)

    if (resp) await this.handleBuscaAcumuladores()

  }

  handleBuscaFiltered(filtro: string) {

    AcumuladoresStore.obs.filter_calculo = filtro
    AcumuladoresStore.obs.acumuladores_current = 1

    this.obs.fetchOptions()

  }

  handleChangeFilterAcumulador = (valueAsNumber: number, valueAsString: string) => {

    AcumuladoresStore.obs.filter_acumulador = valueAsString.replace(/\D/g, "")

    this.obs.fetchOptions()

  }

  async handleBuscaAcumuladores() {

    if (!this.obs.selectEmpresa.cnpj) {
      toast.warn("Favor selecione uma Empresa!", {})
      return
    }

    await AcumuladoresStore.handleBuscaAcumuladores(
      AcumuladoresStore.obs.acumuladores_current,
      this.obs.selectEmpresa.cnpj,
      this.obs.selectEmpresa.uf,
      AcumuladoresStore.obs.filter_calculo,
      AcumuladoresStore.obs.filter_acumulador
    )

  }

  formaterDate = (cell, row) => {

    if (!cell) return ""

    return moment(cell).add(3, "hours").format("DD/MM/YYYY");

  };

  formaterDetalhes = (cell, row) => {
    return (
      <>
        <MDBBtn color="default" rounded size="sm" onClick={() => this.handleEditAjuste(row)}>
          <img src="/images/edit.png" width={15} />
        </MDBBtn>
        <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
          <MDBBtn color="default" rounded size="sm" >
            <img src="/images/bin.png" width="25px" />

          </MDBBtn>
          <div>
            <H5>Confirmar exclusão?</H5>
            <p style={{ fontSize: 11 }}>Tem certeza de que deseja excluir esse item? Você não será capaz de recuperá-lo.</p>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 15,
              }}
            >
              <Button
                className={Classes.POPOVER_DISMISS}
                style={{ marginRight: 10 }}
              >
                Cancelar
              </Button>
              <Button
                intent="danger"
                className={Classes.POPOVER_DISMISS}
                onClick={() => this.handleDeleteAcumulador(row.id)}
              >
                Excluir
              </Button>
            </div>
          </div>
        </Popover>
      </>
    )
  }

  handleCheckCalc = async (row, checked) => {

    if (checked) {

      this.obs.listCalcs.push({ id: row.id, nome: row.nome });

    } else {

      let index = this.obs.listCalcs.findIndex(obj => obj.id === row.id);

      if (index !== -1) {
        this.obs.listCalcs.splice(index, 1);
      }

    }

  };

  handleCheckCalcAll = async (check, row) => {

    if (check) {

      row?.map(value => {

        this.obs.listCalcs.push({ id: value.id, nome: value.nome });

      });

    } else {

      this.obs.listCalcs = []

    }

  };

  onCloseCreate() {

    this.obs.open_create = false

    this.obs.listCalcs = []

    this.obs.id = ""
    this.obs.n_acumulador = ""

  }

  onCloseEdit() {

    this.obs.open_edit = false

    this.obs.id = null
    this.obs.n_acumulador = ""
    this.obs.calc_selecionado = null

  }

  async handleLoadCalcs() {

    AcumuladoresStore.obs.calcs = []

    if (!this.obs.selectEmpresa.cnpj) return

    await AcumuladoresStore.handleCalcsLoad(this.obs.selectEmpresa);

  }

  async handleExportCalculos() {

    this.obs.loading_exportar_modelo = true

    await AcumuladoresStore.handleExportCalculos(this.obs.selectEmpresa);

    this.obs.loading_exportar_modelo = false

  }

  handleFileDropEntradaExcel = async (files: any) => {
    let niveis_acesso = AppStore.obs1.usuario ? AppStore.obs1.usuario.niveis_acesso : [""];

    if (niveis_acesso.indexOf("i1") == -1) {
      toast.warning("Você não possui permissão para importar arquivo SPED", {});
      return
    }

    var data = new FormData();

    data.append("file", files[0])
    data.append("cnpj", this.obs.selectEmpresa.cnpj)
    data.append("uf", this.obs.selectEmpresa.uf)
    data.append("simples_nacional", `${this.obs.selectEmpresa.simples_nacional ?? false}`)
    data.append("simples_nacional_excesso", `${this.obs.selectEmpresa.simples_nacional_excesso ?? false}`)
    data.append("regime_especial_icms_pa", `${this.obs.selectEmpresa.regime_especial_icms_pa ?? false}`)

    this.obs.loading_import = true;
    this.obs.open_importar_acumuladores = false

    let resp = await AcumuladoresStore.handleImportAcumuladores(data);

    await this.handleBuscaAcumuladores()

    if (resp && resp.ok) {

      this.obs.resp_data = resp;

      this.obs.resp_data.erros = resp.erros.map((erro) => {
        const campos = Object.keys(erro).filter(key => key !== "mensagem");
        const nomeCampo = campos[0];
        const valorCampo = erro[nomeCampo];

        return `${nomeCampo.toUpperCase()} : ${valorCampo} - ${erro.mensagem}`;
      });

      this.obs.open_detalhes_import = true;

    }

    this.obs.loading_import = false;

  };

  handleFileDropRejectedExcel = async (files: any) => {

    if (files.length > 1) {
      toast.warning("Apenas um arquivo por vez é liberado para importação.", {});
      return;
    }

    toast.warning("Arquivo inválido, é aceito somente arquivos .xlsx", {});
    return;

  };

  async handleDuplicarAcumuladores() {

    if (!this.obs.selectEmpresaDuplicar.cnpj) {
      toast.warn("Favor selecione uma Empresa Destino!", {})
      return
    }

    this.obs.loading_import = true;
    this.obs.open_copiar_acumuladores = false

    let data = {
      origem: this.obs.selectEmpresa.cnpj,
      destino: this.obs.selectEmpresaDuplicar.cnpj,
      uf: this.obs.selectEmpresaDuplicar.uf,
      simples_nacional: (this.obs.selectEmpresaDuplicar.simples_nacional ?? false),
      simples_nacional_excesso: (this.obs.selectEmpresaDuplicar.simples_nacional_excesso ?? false),
      regime_especial_icms_pa: (this.obs.selectEmpresaDuplicar.regime_especial_icms_pa ?? false)
    }

    let resp = await AcumuladoresStore.handleDuplicarAcumuladores(data);

    await this.handleBuscaAcumuladores()

    if (resp && resp.ok) {

      this.obs.resp_data = resp;

      this.obs.resp_data.erros = resp.erros

      this.obs.open_detalhes_import = true;

    }

    this.obs.loading_import = false;

  }

  async handleDeleteAllAcumuladores() {

    this.obs.open_delete_all = false
    this.obs.loading_delete_all = true;

    let resp = await AcumuladoresStore.handleDeleteAll(this.obs.selectEmpresa.cnpj);

    if (resp) await this.handleBuscaAcumuladores()

    this.obs.loading_delete_all = false;

  }

  async handleExportAcumuladores() {

    this.obs.loading_exportar = true

    await AcumuladoresStore.handleExportAcumuladores(this.obs.selectEmpresa.cnpj, this.obs.selectEmpresa.uf);

    this.obs.loading_exportar = false

  }

  handleLoadAcumuladores() {

    if (this.obs.selectEmpresa.cnpj) {

      this.handleLoadCalcs()
      this.handleChangePage(1)

      this.obs.isEmpresa = true

    } else {

      toast.warn("Selecione uma empresa para prosseguir!", {})

    }

  }

  render() {

    if (!this.obs.isEmpresa) return this.renderBlock();

    return this.renderAcumuladores();

  }

  renderBlock() {

    let empresaText = this.obs.selectEmpresa.cnpj != ""
      ? `${this.obs.selectEmpresa.razao_social.substring(0, 38)}... (${formatCnpj(this.obs.selectEmpresa.cnpj)})`
      : "Selecione uma empresa"

    let titleEmpresaText = this.obs.selectEmpresa.cnpj != ""
      ? this.obs.selectEmpresa.razao_social + " - (" + formatCnpj(this.obs.selectEmpresa.cnpj) + ")"
      : "";

    return (<>

      <MDBCol>
        <MDBRow>
          <MDBBtn className="btnDefault btnBuscarNfe" onClick={() => {
            this.obs.open_select_empresa = true; this.obs.tempSelectEmpresa = this.obs.selectEmpresa;
          }}>Selecionar Empresa</MDBBtn>
          <h2 className="titleSEFAZ titleEmpresaSped">{titleEmpresaText}</h2>
        </MDBRow>
      </MDBCol>

      <div className="nz-non-ideal">
        <NonIdealState
          icon="box"
          description={"Selecione uma Empresa para realizar as Configurações"} />
      </div>

      <Alert
        cancelButtonText="Fechar"
        confirmButtonText="Carregar"
        isOpen={this.obs.open_select_empresa}
        onClose={() => {
          this.obs.selectEmpresa = this.obs.tempSelectEmpresa;
          this.obs.open_select_empresa = false;
        }}
        onConfirm={() => {this.handleLoadAcumuladores(); this.obs.tempSelectEmpresa = this.obs.selectEmpresa;}}
        className="AlertUser"
        canOutsideClickCancel={true}
        intent={Intent.PRIMARY}
      >
        <h2 className="titleSEFAZ">Selecione uma Empresa</h2>
        <FormGroup className="empresaSelect">
          <EmpresaSelect
            items={EmpresaStore.sortedEmpresas}
            itemRenderer={renderEmpresa}
            itemPredicate={filterEmpresa}
            onItemSelect={(e: IEmpresa) => this.obs.selectEmpresa = e}
            inputProps={{ placeholder: "Filtrar uma empresa" }}
          >
            <Button
              text={empresaText}
              alignText={Alignment.LEFT}
              rightIcon={<Icon icon="double-caret-vertical" style={{ padding: 5 }} />}
            />
          </EmpresaSelect>
        </FormGroup>
      </Alert>

    </>)
  }

  renderAcumuladores() {

    let calcs = AcumuladoresStore.obs.calcs?.map(obj => {
      return ({
        id: (obj._id || obj.id),
        nome: obj.nome,
      })
    });

    let acumuladores = AcumuladoresStore.obs.acumuladores?.map(row => {
      return ({
        id: (row._id || row.id),
        n_acumulador: row.n_acumulador,
        calc_id: row.calc_id,
        calc_nome: (row.calc_nome ?? "N/A"),
        inserted_at: row.inserted_at,
      })
    });

    const selectRowClass = {
      mode: "checkbox",
      clickToSelect: true,
      columnWidth: "40px",
      onSelect: this.handleCheckCalc,
      onSelectAll: this.handleCheckCalcAll,
      selected: this.obs.listCalcs.map(x => x.id),
    };

    const options = {
      searchField: this.createCustomSearchFieldSol,
    };

    let empresaDuplicarText = this.obs.selectEmpresaDuplicar.cnpj != ""
      ? `${this.obs.selectEmpresaDuplicar.razao_social.substring(0, 38)}... (${formatCnpj(this.obs.selectEmpresaDuplicar.cnpj)})`
      : "Selecione uma empresa"

    let empresaText = this.obs.selectEmpresa.cnpj != ""
      ? `${this.obs.selectEmpresa.razao_social.substring(0, 38)}... (${formatCnpj(this.obs.selectEmpresa.cnpj)})`
      : "Selecione uma empresa"

    let calcText = !this.obs.calc_selecionado?.nome
      ? "Selecione o Cálculo"
      : `${this.obs.calc_selecionado.nome.length >= 100
        ? this.obs.calc_selecionado.nome.substring(0, 100) + "..."
        : this.obs.calc_selecionado.nome}`

    const renderErroItem = (msg, index) => (
      <div className="detalheImportItem detalheImportItem--erro" key={index}>
        <Icon icon="error" className="detalheImportItemIcon" />
        <span className="detalheImportItemMsg">{msg}</span>
      </div>
    );

    const errosList = this.obs.resp_data?.erros || [];

    let errosValidate = errosList.length;
    let importadosValidate = this.obs.resp_data?.sucesso;
    let errosText = errosList.map(renderErroItem);

    let titleEmpresaText = this.obs.selectEmpresa.cnpj != ""
      ? this.obs.selectEmpresa.razao_social + " - (" + formatCnpj(this.obs.selectEmpresa.cnpj) + ")"
      : "";

    return (
      <>

        <MDBCol>
          <MDBRow>
            <MDBBtn className="btnDefault btnBuscarNfe" onClick={() => {
              this.obs.open_select_empresa = true; this.obs.tempSelectEmpresa = this.obs.selectEmpresa;
            }}>Selecionar Empresa</MDBBtn>
            <h2 className="titleSEFAZ titleEmpresaSped">{titleEmpresaText}</h2>
          </MDBRow>
        </MDBCol>

        <MDBRow style={{ marginTop: 40, marginBottom: 5 }}>
          <MDBCol md="3">
            <FormGroup className="form-group" label="Filtrar Acumulador">
              <NumericInput
                className="input-numeric"
                value={AcumuladoresStore.obs.filter_acumulador}
                onValueChange={this.handleChangeFilterAcumulador}
                buttonPosition="none"
                placeholder="Exemplo: 1"
                min={0}
                minorStepSize={null}
                allowNumericCharactersOnly
              />
            </FormGroup>
          </MDBCol>

          <MDBCol md="3">
            <FormGroup label="Filtrar Cálculo">
              <InputGroup
                round
                style={{ borderRadius: 10 }}
                placeholder="Exemplos: ICMS 1152, 6419ae04976bc4a9d5a97148"
                value={AcumuladoresStore.obs.filter_calculo}
                onChange={(e: any) => this.handleBuscaFiltered(e.target.value)}
              />
            </FormGroup>
          </MDBCol>

          <MDBCol>
            <div style={{ display: "flex", gap: 5, float: "right", marginTop: 28 }}>
              <Button
                text="Criar Acumulador"
                className="btnDefault btnBuscarNfe btnVerde"
                onClick={() => this.handleOpenCreate()}
                disabled={!this.obs.selectEmpresa.cnpj}
              />

              <Popover
                position={Position.BOTTOM_RIGHT}
                content={
                  <Menu>
                    <MenuItem
                      text={
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          <AppIcon name="table_edit" size={24} color="#3e6971" />
                          <span>Baixar Modelo</span>
                        </div>
                      }
                      onClick={() => this.handleExportCalculos()}
                    />

                    <MenuItem
                      text={
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          <AppIcon name="upload" size={24} color="#3e6971" />
                          <span>Importar Acumuladores</span>
                        </div>
                      }
                      onClick={() => {
                        this.obs.open_importar_acumuladores = true;
                      }}
                    />

                    <MenuItem
                      text={
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          <AppIcon name="download" size={24} color="#3e6971" />
                          <span>Exportar Acumuladores</span>
                        </div>
                      }
                      onClick={() => this.handleExportAcumuladores()}
                    />

                    <MenuItem
                      text={
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          <AppIcon name="copy_all" size={24} color="#3e6971" />
                          <span>Copiar Acumuladores</span>
                        </div>
                      }
                      onClick={() => {
                        this.obs.selectEmpresaDuplicar = newEmpresa();
                        this.obs.open_copiar_acumuladores = true;
                      }}
                    />

                    <MenuItem
                      text={
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          <AppIcon name="delete" size={24} color="#3e6971" />
                          <span>Excluir todos Acumuladores</span>
                        </div>
                      }
                      onClick={() => {
                        this.obs.open_delete_all = true;
                      }}
                    />
                  </Menu>
                }
              >
                <Button
                  text="Ações"
                  rightIcon="caret-down"
                  className="btnDefault btnAcoes"
                />
              </Popover>
            </div>
          </MDBCol>
        </MDBRow>

        <BootstrapTable className="TabelaSimples" data={acumuladores}>
          <TableHeaderColumn dataField="id" width="1%" isKey={true} hidden >#</TableHeaderColumn>
          <TableHeaderColumn dataField="n_acumulador" width="15%">Nº Acumulador</TableHeaderColumn>
          <TableHeaderColumn dataField="calc_nome" width="60%">Cálculo</TableHeaderColumn>
          <TableHeaderColumn dataFormat={this.formaterDate} dataField="inserted_at" width="20%">Criado em</TableHeaderColumn>
          <TableHeaderColumn dataFormat={this.formaterDetalhes} width="20%">Ações</TableHeaderColumn>
        </BootstrapTable>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={AcumuladoresStore.obs.acumuladores_current}
            totalCount={AcumuladoresStore.obs.acumuladores_length}
            pageSize={20}
            onPageChange={(page) => this.handleChangePage(page)}
          />
        </div>

        <div style={{ marginBottom: 120 }} />

        <Dialog
          isOpen={this.obs.open_create}
          className="AlertUser modalSefa modalAjusteSped"
          onClose={() => this.onCloseCreate()}>
          <h2 className="titleSEFAZ modal-sefa">{"Novo Acumulador"}</h2>

          <FormGroup className="form-group" label="Acumulador" labelInfo="*" style={{ width: "20%" }}>
            <InputGroup type="text" onChange={(e) => this.obs.n_acumulador = e.target.value} value={this.obs.n_acumulador} placeholder="Exemplo: 666" />
          </FormGroup>

          {this.obs.selectEmpresa.cnpj && (

            <FormGroup label="Selecione os Cálculos" labelInfo="*">
              <div className="select-empresa-ajuste">
                <BootstrapTable data={calcs} selectRow={selectRowClass} options={options} search>
                  <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
                  <TableHeaderColumn dataField="nome" width="90%">Nome</TableHeaderColumn>
                </BootstrapTable>
              </div>
            </FormGroup>
          )}

          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Cancelar" onClick={() => this.onCloseCreate()} />
            <Button text="Salvar" intent="primary" onClick={() => this.handleSaveCreate()} />
          </div>

        </Dialog>

        <Dialog
          isOpen={this.obs.open_edit}
          className="AlertUser modalSefa"
          onClose={() => this.onCloseEdit()}
        >
          <div style={{ marginBottom: 15 }}>
            <h2 className="titleSEFAZ modal-sefa">{"Editar Acumulador"}</h2>

            <FormGroup className="form-group" label="Acumulador" labelInfo="*" style={{ width: "20%" }}>
              <InputGroup type="text" onChange={(e) => this.obs.n_acumulador = e.target.value} value={this.obs.n_acumulador} placeholder="Exemplo: 666" />
            </FormGroup>

            <FormGroup
              label={<>Cálculo <span className="contestar-required">*</span></>}
              className="empresaSelect calcSelect"
            >
              <CalcSelect
                items={AcumuladoresStore.obs.calcs}
                itemRenderer={renderCalcs}
                itemPredicate={filterCalcs}
                onItemSelect={(e: ICalc) => this.obs.calc_selecionado = e}
                inputProps={{ placeholder: "Filtrar um Cálculo" }}
                matchTargetWidth
              >
                <Button text={calcText} rightIcon="double-caret-vertical" alignText={Alignment.LEFT} />
              </CalcSelect>
            </FormGroup>
          </div>

          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Cancelar" onClick={() => this.onCloseEdit()} />
            <Button text="Salvar" intent="primary" onClick={() => this.handleSaveEdit()} />
          </div>

        </Dialog>

        <Dialog
          usePortal={true} isOpen={this.obs.open_erros} onClose={() => { this.obs.open_erros = false; this.obs.erros = []; }} className="alertErros">
          <h2 className="titleSEFAZ">Erros ocorridos durante o Cadastro</h2>

          <div style={{ height: 400, overflow: "auto", marginBottom: 15 }}>
            <ReactJson
              collapsed={false}
              displayDataTypes={false}
              src={this.obs.erros}
            />
          </div>

          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Fechar" intent="primary" onClick={() => { this.obs.open_erros = false; this.obs.erros = []; }} />
          </div>
        </Dialog>

        <Alert
          confirmButtonText="Fechar"
          isOpen={this.obs.open_importar_acumuladores}
          onClose={() => this.obs.open_importar_acumuladores = false}
          canOutsideClickCancel={true}
        >
          <h2 className="titleSEFAZ">Importar planilha Acumuladores</h2>

          <p style={{ color: "red" }}>
            <b>Atenção:</b> Para a correta importação da planilha, é imprescindível que a estrutura e a ordem das colunas permaneçam conforme o <br />
            padrão gerado inicialmente pelo sistema, qualquer alteração poderá resultar na invalidação do documento.
            <br />
            <br />
            <i>Registros com o mesmo <b>Acumulador</b> e <b>Cálculo</b> serão sobrescritos pelo que estão sendo importados!</i>
          </p>

          <Dropzone
            accept={{ "files/txt": [".xlsx"] }}
            maxFiles={1}
            multiple={false}
            onDropAccepted={this.handleFileDropEntradaExcel}
            onDropRejected={this.handleFileDropRejectedExcel}
          >
            {({ getRootProps, getInputProps }) => (
              <>
                <div {...getRootProps()} style={{ marginBottom: 20 }}>
                  <input {...getInputProps()} />
                  <Button
                    icon="upload"
                    text="Selecionar Excel para importação"
                    className="btn-file btnDefault noMargin"
                  />
                </div>

                <div {...getRootProps()} className="nz-upload-box">
                  <input {...getInputProps()} />
                  <Icon icon="upload" iconSize={60} />
                  <span style={{ marginLeft: 20 }}>
                    Arraste o arquivo para importar.{" "}
                  </span>
                </div>
              </>
            )}
          </Dropzone>
        </Alert>

        <Dialog
          isOpen={this.obs.open_detalhes_import}
          title="Detalhes"
          onClose={() => this.obs.open_detalhes_import = false}
          className="detalhesImportDialog"
        >
          <div className={Classes.DIALOG_BODY}>
            <div className="detalheImportResumo">
              <div className="detalheImportResumoItem">
                <span className="detalheImportResumoNum">{this.obs.resp_data.total_dados}</span>
                <span className="detalheImportResumoLabel">Total de Registros</span>
              </div>
              <div className="detalheImportResumoItem">
                <span className="detalheImportResumoNum detalheImportResumoNum--ok">{this.obs.resp_data.sucesso}</span>
                <span className="detalheImportResumoLabel">Total de Cadastros</span>
              </div>
              <div className="detalheImportResumoItem">
                <span className={this.obs.resp_data.total_erros >= 1
                  ? "detalheImportResumoNum detalheImportResumoNum--erro"
                  : "detalheImportResumoNum"}>{this.obs.resp_data.total_erros}</span>
                <span className="detalheImportResumoLabel">Todal de Erros</span>
              </div>
            </div>

            {!errosValidate && !importadosValidate ?
              <div className="detalheImportSucesso">
                <img src="/images/pass_calculo.png" width={44} />
                <h3>Nenhum registro processado</h3>
                <p>A planilha não retornou cadastros nem erros.</p>
              </div>
              :
              <>
                {errosValidate
                  ? <>
                    <div className="detalheImportSeg">
                      <button type="button" className={"detalheImportSegBtn is-active"}>Erros
                        <span className="detalheImportSegCount detalheImportSegCount--erro">{errosValidate}</span>
                      </button>
                    </div>

                    <div className="detalheImportLista">
                      <div className="detalheImportListaScroll">
                        {errosText}
                      </div>
                    </div>

                  </>

                  : <>

                    <div className="detalheImportSucesso">
                      <img src="/images/pass_calculo.png" width={44} />
                      <h3>Todos os registros foram processados com sucesso!</h3>
                    </div>

                  </>

                }
              </>
            }
          </div>
          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Fechar" intent="primary" onClick={() => this.obs.open_detalhes_import = false} />
            </div>
          </div>
        </Dialog>

        <Dialog
          isOpen={this.obs.open_copiar_acumuladores}
          onClose={() => this.obs.open_copiar_acumuladores = false}
        >
          <h2 className="titleSEFAZ">Copiar Acumuladores</h2>

          <p style={{ color: "red" }}>
            <b>Atenção:</b> Todos os acumuladores da <b>Empresa Origem</b> serão copiados para a <b>Empresa Destino</b>. Caso já existam acumuladores com o <br />
            mesmo <b>Acumulador</b> e <b>Cálculo</b>, os dados existentes serão sobrescritos.
          </p>

          <FormGroup className="empresaSelect" label="Empresa Origem">
            <EmpresaSelect
              items={EmpresaStore.sortedEmpresas}
              itemRenderer={renderEmpresa}
              itemPredicate={filterEmpresa}
              onItemSelect={(e: IEmpresa) => this.obs.selectEmpresa = e}
              disabled
            >
              <Button text={empresaText}
                alignText={Alignment.LEFT}
                disabled
                rightIcon={
                  <Icon icon="double-caret-vertical" style={{ padding: 5 }} />
                } />
            </EmpresaSelect>
          </FormGroup>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 8,
              margin: "10px 0 14px",
              fontWeight: 600
            }}
          >
            <Icon icon="arrow-down" />
            <span>Copiar acumuladores para</span>
          </div>

          <FormGroup className="empresaSelect" label="Empresa Destino">
            <EmpresaSelect
              items={EmpresaStore.sortedEmpresas}
              itemRenderer={renderEmpresa}
              itemPredicate={filterEmpresa}
              onItemSelect={(e: IEmpresa) => this.obs.selectEmpresaDuplicar = e}
              inputProps={{ placeholder: "Filtrar uma empresa" }}
            >
              <Button
                text={empresaDuplicarText}
                alignText={Alignment.LEFT}
                rightIcon={
                  this.obs.selectEmpresaDuplicar.cnpj ? (
                    <Icon
                      className="clear-icon-empresa"
                      icon="cross"
                      onClick={(ev) => {
                        ev.stopPropagation();
                        this.obs.selectEmpresaDuplicar = newEmpresa();
                      }}
                    />
                  ) : (
                    <Icon icon="double-caret-vertical" style={{ padding: 5 }} />
                  )
                }
              />
            </EmpresaSelect>
          </FormGroup>

          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Fechar" onClick={() => this.obs.open_copiar_acumuladores = false} />
            <Button text="Copiar" intent="primary" onClick={() => this.handleDuplicarAcumuladores()} />
          </div>

        </Dialog>

        <Dialog
          isOpen={this.obs.open_delete_all}
          onClose={() => this.obs.open_delete_all = false}
        >
          <h2 className="titleSEFAZ">Confirmar exclusão?</h2>

          <p style={{ fontSize: 11 }}>
            Tem certeza de que deseja excluir todos os acumuladores cadastrados para a empresa <b>{this.obs.selectEmpresa.razao_social}</b>? Esta ação não poderá ser desfeita.
          </p>

          <br />

          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Cancelar" onClick={() => this.obs.open_delete_all = false} />
            <Button text="Excluir" intent="danger" onClick={() => this.handleDeleteAllAcumuladores()} />
          </div>

        </Dialog>

        <Alert
          cancelButtonText="Fechar"
          confirmButtonText="Carregar"
          isOpen={this.obs.open_select_empresa}
          onClose={() => {
            this.obs.selectEmpresa = this.obs.tempSelectEmpresa;
            this.obs.open_select_empresa = false;
          }}
          onConfirm={() => {this.handleLoadAcumuladores(); this.obs.tempSelectEmpresa = this.obs.selectEmpresa;}}
          className="AlertUser"
          canOutsideClickCancel={true}
          intent={Intent.PRIMARY}
        >
          <h2 className="titleSEFAZ">Selecione uma Empresa</h2>
          <FormGroup className="empresaSelect">
            <EmpresaSelect
              items={EmpresaStore.sortedEmpresas}
              itemRenderer={renderEmpresa}
              itemPredicate={filterEmpresa}
              onItemSelect={(e: IEmpresa) => this.obs.selectEmpresa = e}
              inputProps={{ placeholder: "Filtrar uma empresa" }}
            >
              <Button
                text={empresaText}
                alignText={Alignment.LEFT}
                rightIcon={<Icon icon="double-caret-vertical" style={{ padding: 5 }} />}
              />
            </EmpresaSelect>
          </FormGroup>
        </Alert>

        <LoadingModal open={this.obs.loading_save} onClose={() => this.obs.loading_save = false} title={"Salvando"} />
        <LoadingModal open={this.obs.loading_import} onClose={() => this.obs.loading_import = false} title={"Importando acumuladores"} />
        <LoadingModal open={this.obs.loading_copiar} onClose={() => this.obs.loading_copiar = false} title={"Copiando acumuladores"} />
        <LoadingModal open={this.obs.loading_exportar} onClose={() => this.obs.loading_exportar = false} title={"Exportando acumuladores"} />
        <LoadingModal open={this.obs.loading_exportar_modelo} onClose={() => this.obs.loading_exportar_modelo = false} title={"Exportando planilha modelo"} />
        <LoadingModal open={this.obs.loading_delete_all} onClose={() => this.obs.loading_delete_all = false} title={"Deletando acumuladores"} />

      </>
    );
  }
}